import { makeStyles, OutlineButton } from '@bb-ui/react-library';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentView } from '@bb-ui/icons/dist/small';
import { ReleaseStageMembersDialog } from 'pages/ReleaseStageMembers';

const useStyles = makeStyles(() => ({
  button: {
    minWidth: 'auto',
    height: '1.5rem',
    padding: '0.2rem 0.5rem',
    fontSize: '0.75rem',
  },
}));

export interface ReleaseStageMembersButtonProps {
  releaseStageId: string;
  releaseStageName: string;
  targetReleaseVersion: string;
  lastReleaseVersion?: string;
  onReload: () => void;
}

export const ReleaseStageMembersButton: React.FunctionComponent<ReleaseStageMembersButtonProps> = ({
  releaseStageId,
  releaseStageName,
  targetReleaseVersion,
  lastReleaseVersion,
  onReload,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <OutlineButton
        startIcon={<ContentView />}
        data-testid="instances-button-release-stage"
        onClick={() => setOpen(true)}
        className={classes.button}
      >
        {t('releaseStageMembers.button')}
      </OutlineButton>
      <ReleaseStageMembersDialog
        id={`release-stage-members-${releaseStageId}`}
        open={open}
        onClose={() => setOpen(false)}
        releaseStageId={releaseStageId}
        releaseStageName={releaseStageName}
        targetReleaseVersion={targetReleaseVersion}
        lastReleaseVersion={lastReleaseVersion}
        onReleaseStageUpdated={onReload}
      />
    </>
  );
};
